import {
  MotifButton,
  MotifFormField,
  MotifIcon,
  MotifSearch,
} from '@ey-xd/motif-react';
import { UploadSvgIcon } from '../../common/MotifIcons';
import './fileUpload.scss';

export const TableHeader = ({ onFilterTextBoxChanged, searchValue, navigation }) => (
  <div className='grid-header'>
    <div className='header-input'>
      <MotifFormField>
        <MotifSearch
          aria-label='Search'
          onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
          placeholder='Search for...'
          value={searchValue}
        />
      </MotifFormField>
    </div>
    <div className='header-upload'>
      <MotifButton
        onClick={() => navigation('/steps/files/upload')}
        size='small'
        type='submit'
        variant='primary'
      >
        <MotifIcon src={UploadSvgIcon} title='Upload' fill='none' />
        Upload Data
      </MotifButton>
    </div>
  </div>
);
